(function () {
  const initGlossary = (root = document) => {
    const cards = root.querySelectorAll(
      ".glossary-card:not([data-glossary-init])"
    );

    cards.forEach((card) => {
      card.setAttribute("data-glossary-init", "true");

      const excerpt = card.querySelector(".glossary-excerpt");
      const btn = card.querySelector(".glossary-toggle");
      const listItems = excerpt?.querySelectorAll("li") || [];

      if (!excerpt || !btn || listItems.length === 0) return;

      const showMore = excerpt.dataset.showMore || "Show more";
      const showLess = excerpt.dataset.showLess || "Show less";
      const collapsedHeight = excerpt.dataset.collapsedHeight || "89px";

      let fullHeight;

      const measureHeight = () => {
        excerpt.style.maxHeight = "none";
        fullHeight = excerpt.scrollHeight;
        excerpt.dataset.fullHeight = fullHeight;
      };

      measureHeight();
      excerpt.style.maxHeight = collapsedHeight;

      const collapsedHeightPx = parseInt(collapsedHeight, 10);

      if (fullHeight <= collapsedHeightPx) {
        btn.style.display = "none";
        return;
      }

      btn.style.display = "flex";

      const updateButton = () => {
        const expanded = excerpt.classList.contains("expanded");
        const textClass = "glossary-toggle-text";
        let textEl = btn.querySelector("." + textClass);
        if (!textEl) {
          textEl = document.createElement("span");
          textEl.className = textClass;
          btn.insertBefore(textEl, btn.firstChild);
        }
        textEl.textContent = expanded ? showLess : showMore;
      };

      updateButton();

      let isAnimating = false;

      btn.addEventListener("click", () => {
        if (isAnimating) return;

        isAnimating = true;

        excerpt.classList.toggle("expanded");
        btn.classList.toggle("expanded");
        updateButton();

        if (excerpt.classList.contains("expanded")) {
          excerpt.style.maxHeight = excerpt.dataset.fullHeight + "px";
        } else {
          excerpt.style.maxHeight = collapsedHeight;
        }
      });

      excerpt.addEventListener("transitionend", () => {
        isAnimating = false;
      });

      new ResizeObserver(() => {
        if (isAnimating) return;

        excerpt.style.transition = "none";

        measureHeight();

        if (excerpt.classList.contains("expanded")) {
          excerpt.style.maxHeight = excerpt.dataset.fullHeight + "px";
        } else {
          excerpt.style.maxHeight = collapsedHeight;
        }

        void excerpt.offsetHeight;

        excerpt.style.transition = "";
      }).observe(excerpt);
    });
  };

  document.addEventListener("DOMContentLoaded", () => initGlossary());
  document.addEventListener("shopify:section:load", (e) =>
    initGlossary(e.target)
  );
  document.addEventListener("shopify:section:select", (e) =>
    initGlossary(e.target)
  );
})();
